import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getUserInfo } from 'actions/index';
import cx from "classnames";
import './styles.scss';
import UserMenu from './UserMenu';

const mapStateToProps = state => ({
	isPopupOpen: state.ui.isUserPopupOpen,
});

const mapDispatchToProps = { getUserInfo };

@connect(mapStateToProps, mapDispatchToProps)
class UserInfo extends PureComponent {
	componentDidMount () {
		this.props.getUserInfo();
	}
	
	render () {
		return (
			<div className={cx('userBoxContainer', { open: this.props.isPopupOpen})}>
				<UserMenu />
			</div>
		);
	}
}

UserInfo.propTypes = {
	showLangMenu: PropTypes.bool,
	getUserInfo: PropTypes.func,
};

export default UserInfo;
